module.exports = __webpack_public_path__ + "images/assets/1a92bd4671a78823d5c1967b39620db6.svg";